// extracted by mini-css-extract-plugin
export default {"container":"Error_container__BG3Y9","heading":"Error_heading__4GUcf","message":"Error_message__B2cJI"};